import styled from "styled-components";

const FlapContainerContent = styled.div<{ right?: boolean }>`
  background-color: ${(props) => props.theme.colors.white};
  min-width: 250px;
  margin-top: 5px;
  border: 1px solid ${(props) => props.theme.colors.grays4};
  border-radius: ${(props) => props.theme.borderRadius.small};
  padding: 10px 0 10px 0;
  overflow: hidden;
`;

export default FlapContainerContent;
